import React, { useState, useEffect } from "react";
import {
  Typography, Box, Grid, TextField, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, IconButton, Button, Dialog, DialogActions,
  DialogContent, DialogTitle
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { deleteKeyDetail } from "../Dossier/Network_call";
import { toast  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Contacts = ({ onContactsChange, dossierData, refreshDossierData }) => {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [persona, setPersona] = useState("");
  const [contacts, setContacts] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [disabledDeleteButtons, setDisabledDeleteButtons] = useState({});

  useEffect(() => {
    if (dossierData && dossierData.contacts) {
      setContacts(dossierData.contacts);
    }
  }, [dossierData]);

  const handleOpen = () => {
    setId("");
    setName("");
    setPersona("");
    setEditIndex(null);
    setIsSaveDisabled(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (name && persona) {
      const newContact = { id, name, persona };
      console.log("newwww", newContact);
      console.log("edit indexxxxx", editIndex);
      let updatedContacts;
      if (editIndex !== null) {
        updatedContacts = contacts.map((contact, index) =>
          index === editIndex ? newContact : contact
        );
      } else {
        updatedContacts = [...contacts, newContact];
      }
      setContacts(updatedContacts);
      console.log("updated", updatedContacts)
      onContactsChange(updatedContacts);
      setIsSaveDisabled(true); 
      handleClose();
    }
  };

  const handleEdit = (index) => {
    const contact = contacts[index];
    setId(contact.id);
    setName(contact.name);
    setPersona(contact.persona);
    setEditIndex(index);
    setIsSaveDisabled(false);
    setOpen(true);
  };

  /* const handleDelete = async(index) => {
    const contact = contacts[index];
    const updatedContacts = contacts.filter((_, i) => i !== index);
    try {
      setDisabledDeleteButtons(prev => ({ ...prev, [index]: true }));
      const res = await deleteKeyDetail({id: {contact: contact.id}});
      setContacts(updatedContacts);
      onContactsChange(updatedContacts);
      refreshDossierData();
      
      toast.success("Contact deleted successfully");
    } catch (error) {
      toast.error("Failed to delete contact");
      setDisabledDeleteButtons(prev => ({ ...prev, [index]: false }));
    }
  }; */


  const handleDelete = async (index) => {
    const contact = contacts[index];
    const updatedContacts = contacts.filter((_, i) => i !== index);
    try {
      setDisabledDeleteButtons(prev => ({ ...prev, [index]: true }));
      
      await deleteKeyDetail({ id: { contact: contact.id } });
      
      setContacts(updatedContacts);
      onContactsChange(updatedContacts);
      refreshDossierData();
  
      toast.success("Contact deleted successfully");
  
      setDisabledDeleteButtons(prev => {
        const updatedState = { ...prev };
        delete updatedState[index]; 
        return updatedState;
      });
    } catch (error) {
      toast.error("Failed to delete contact");
  
      setDisabledDeleteButtons(prev => ({ ...prev, [index]: false }));
    }
  };
  

  return (
    <Box sx={{ p: 3, bgcolor: '#ffffff' }}>
      
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#00A0B2" }}>
        Contacts
      </Typography>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{ mb: 2, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
      >
        Add Contact
      </Button>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Persona</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map((contact, index) => (
              <TableRow key={index}>
                <TableCell>{contact.name}</TableCell>
                <TableCell>{contact.persona}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(index)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(index)}
                    disabled={disabledDeleteButtons[index]}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editIndex !== null ? "Edit Contact" : "Add Contact"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Persona"
                variant="outlined"
                value={persona}
                onChange={(e) => setPersona(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="space-between" sx={{ px: 2, py: 1 }}>
            <Button
              onClick={handleSave}
              disabled={isSaveDisabled}
              sx={{
                backgroundColor: '#1976d2',
                color: '#fff',
                '&:hover': { backgroundColor: '#1565c0' },
              }}
            >
              {editIndex !== null ? "Edit" : "Set"}
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                '&:hover': { backgroundColor: '#c62828' },
              }}
            >
              Cancel
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      
    </Box>
  );
};

export default Contacts;
